import HighlightedSpecsAttrs from '../../../../components/highlighted-specs/highlighted-specs-attrs.desktop';
import highlightedSpecsMapAttrs from './highlighted-specs-map-attrs';

export default highlightedSpecsMapAttrs(HighlightedSpecsAttrs);
